// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import { openKLView } from '../../modules/koh-lanta/actions/routes';
import { selectIsKLEnabled } from '../../modules/koh-lanta/selectors/runtime';
import { selectShowOperationBanners } from '../../selectors/operations.selector';

import MenuDesktopKLButton from './MenuDesktopKLButton';
import selectKLButtonProps from './MenuDesktopKLButton.selector';

const MenuDesktopKLButtonContainer = () => {
  const isKLEnabled = useSelector(selectIsKLEnabled);
  const showOperationBanners = useSelector(selectShowOperationBanners);
  const selectedProps = useSelector(selectKLButtonProps);

  const memoizedActions = useMemo(
    () => ({
      openKLView,
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(memoizedActions);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return isKLEnabled && showOperationBanners ? <MenuDesktopKLButton {...enhancedProps} /> : null;
};

export default MenuDesktopKLButtonContainer;
